"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.carPurchaseCalculator = void 0;
/*
    seat 座位数 number
    baseCarPrice 最低报价 number
    newEnergy 是否是新能源  0=》不是  1=》是
    rates  首付比例  floatNumber
    months  分期月数 number
    displacement 排量 floatNumber
    yearRate 年化利率 floatNumber
    type 是否月复利  string  1是  2否
    */
function carPurchaseCalculator(options) {
    var seat = options.seat || 6;
    var newEnergy = options.newEnergy || 0;
    var baseCarPrice = options.baseCarPrice || 1000000;
    var rates = options.rates || 0.1;
    var months = options.months || 60;
    var displacement = options.displacement || 1.0;
    var yearRate = options.yearRate || 3;
    var isThanSixSeat = seat >= 6;
    var type = options.type || 1;
    // let allCost = 0;
    //   1. 首付金额 =
    //  默认30%，可以切换
    //   = 必要花费 + 保险 + 其他贷款费用 + 自定义项 + 裸车价 * 首付比例
    //    如果是自定义的话 上面首付金额自定义
    // 2. 利率 = 默认6.4% 可以自定义
    // 3. 月供金额
    //  = 贷款额度 * (( rate  * Math.pow(1+rate, 贷款的月数)) / (Math.pow(1+rate, 贷款月数) -1))
    //    贷款额度 = 裸车价格 + 必要花费 + 商业保险 + 其他贷款费用 + 自定义项 - 首付金额  ----
    //    rate利率 = 6.4 / 100 / 12 (6.4是默认的可以自己定义)
    // 4. 贷款总花费
    //   = 首付 + 月供*年限
    // 1. 全款花费 = 必要花费 + 商业保险 + 自定义项花费 + （贷款金额）
    // 2. 裸车价格 =
    //   a. 自己输入
    //     b. url根据productId 获取车辆信息
    //     c. 选中某个车型 查找价格
    // 裸车价格
    if (baseCarPrice == 0) {
        return;
    }
    // 3. 必要花费 = a + b + c + d + e
    //    a. 购置税（不可编辑🙅）  = 裸车价格 / 11.3
    //        四舍五入保留整数
    //        纯电、插电混动免征这项税
    var gzs = Math.round(baseCarPrice / 11.3);
    //    b. 购车服务费(出库、上牌费用) = 500(默认)
    //     可编辑
    var fwf = 500;
    //   c. 车船使用税（不可编辑🙅） = 根据排量计算
    //                x < 1.0   250 元
    //         1.0 <= x < 1.6   360 元
    //         1.6 <= x < 2.0   420 元
    //         2.0 <= x < 2.5   720 元
    //         2.5 <= x < 3.0   1800 元
    //         3.0 <= x < 4.0   3000 元
    //         4.0 <  x         4500 元
    //         纯电、插电混动免征
    var ccs = 0;
    var x = parseFloat(displacement + '');
    // let x = parseFloat("1.5L")
    if (x <= 1.0) {
        ccs = 250;
    }
    else if (1.0 < x && x <= 1.6) {
        ccs = 360;
    }
    else if (1.6 < x && x <= 2.0) {
        ccs = 420;
    }
    else if (2.0 < x && x <= 2.5) {
        ccs = 720;
    }
    else if (2.5 < x && x <= 3.0) {
        ccs = 1800;
    }
    else if (3.0 < x && x <= 4.0) {
        ccs = 3000;
    }
    else if (4.0 < x) {
        ccs = 4500;
    }
    //    d. 交强险 = 950(默认)
    //     可以编辑
    var qx = 950;
    //    e. 增加消费税  = 裸车价 / 11.6 四舍五入保留整数
    //       为什么又可以编辑，又可以固定
    //       （裸车价130w以上收取 ）
    var zjxfs = baseCarPrice > 1300000 ? parseInt(baseCarPrice / 11.6 + '') : 0;
    // 4. 商业保险 = 选中的以下项的值的和 a + b + c + d + e + f + g+ h + i + j
    //   a. 第三责任险  -- 可以选择
    //    1. 没有选中 / 没有车的价格  =  0
    //       2. 判断车座位数量
    //         count < 6 -- 6座以下
    //            50000  -- 516
    //            100000 -- 746
    //            200000 -- 924
    //            500000 -- 1252
    //            1000000 -- 1630
    //            default -- 746
    //          count >= 6 --> 大于6座
    //            50000  -- 478
    //            100000 -- 674
    //            200000 -- 821
    //            500000 -- 1094
    //            1000000 -- 1425
    //            default -- 674
    var resPrice = 0;
    switch (100000) {
        case 5 * 10000:
            resPrice = isThanSixSeat ? 478 : 516;
            break;
        case 10 * 10000:
            resPrice = isThanSixSeat ? 674 : 746;
            break;
        case 20 * 10000:
            resPrice = isThanSixSeat ? 821 : 924;
            break;
        case 50 * 10000:
            resPrice = isThanSixSeat ? 1094 : 1252;
            break;
        case 100 * 10000:
            resPrice = isThanSixSeat ? 1425 : 1630;
            break;
        default:
            resPrice = isThanSixSeat ? 674 : 746;
            break;
    }
    //    b. 车辆损失险 = 基础保费 + 裸车价格 * 1.0880%
    //     1. 没有选中 = 0
    //        2. 选中
    //      基础保费 小于6座 459
    //      基础保费 大于6座 550  基础保费 = 车座数 < 6 ? 459 : 550
    //         = parseInt(基础保费 + 落车价格 * 0.01088)
    var clssx = 0;
    if (seat >= 6) {
        clssx = parseInt(550 + baseCarPrice * 0.01088 + '');
    }
    else {
        clssx = parseInt(459 + baseCarPrice * 0.01088 + '');
    }
    //    c. 全车盗抢险 = 基础保费 + 裸车价格 * 费率
    //       1. 没有选中 = 0
    //       2. 选中
    //          基础保费 = 车座数 < 6 ? 102 : 119
    //          费率 = 车座数 < 6 ? 0.004505 : 0.00374
    //     = parseInt(基础保费 + 裸车价格 * 费率)
    var qcdqx = 0;
    if (seat >= 6) {
        qcdqx = Math.round(119 + baseCarPrice * 0.00374);
    }
    else {
        qcdqx = Math.round(102 + baseCarPrice * 0.004505);
    }
    //    e. 自燃损失险 = 新车购置价 * 0.15%
    //      = parseInt(裸车价格 * 0.0015)
    var zrssx = Math.round(baseCarPrice * 0.0015);
    //    f. 不计免赔特约险 = (车辆损失险 + 第三责任险) * 20%
    //    =  parseInt(( b + a ) * 20%)
    var bjmptyx = Math.round((clssx + resPrice) * 0.2);
    //    g. 无过责任险 = 第三责任险 * 20%
    //      = parseInt(a * 20%)
    var wgzrx = Math.round(resPrice * 0.2);
    //    h. 车上人员责任险 =
    var csryzrx = 50;
    //    i. 玻璃单独破碎险 = 裸车价格 * 费率
    //    判断是否是国产  有选项
    //       费率 = 国产 ? 0.0015 : 0.0025
    //       = parseInt(裸车价 * 费率)
    var blx = Math.round(baseCarPrice * 0.0015);
    //    j. 车身划痕险 =
    //     x = 2000
    //     车价 > 0 && <= 300000
    //           = 400
    //         车价 > 300000 && <= 500000
    //           = 585
    //         车价 > 500000
    //           = 850
    //       x = 5000
    //     车价 > 0 && <= 300000
    //      = 570
    //     车价 > 300000 && <= 500000
    //      = 900
    //         车价 > 500000
    //      = 1100
    //       x = 10000
    //     车价 > 0 && <= 300000
    //           = 7600
    //     车价 > 300000 && <= 500000
    //           = 1170
    //         车价 > 500000
    //           = 1500
    //       x = 20000
    //     车价 > 0 && <= 300000
    //      = 1140
    //     车价 > 300000 && <= 500000
    //      = 1780
    //         车价 > 500000
    //      = 2250
    var cshhx = 0;
    if (baseCarPrice > 0 && baseCarPrice <= 300000) {
        cshhx = 570;
        //     车价 > 300000 && <= 500000
        //      = 900
        //         车价 > 500000
        //      = 1100
    }
    else if (baseCarPrice > 300000 && baseCarPrice <= 500000) {
        cshhx = 900;
    }
    else {
        cshhx = 1100;
    }
    var value = baseCarPrice;
    switch (value) {
        case value > 0 && value <= 300000:
            cshhx = 400;
            break;
        case 10 * 10000:
            resPrice = isThanSixSeat ? 674 : 746;
            break;
        case 20 * 10000:
            resPrice = isThanSixSeat ? 821 : 924;
            break;
        case 50 * 10000:
            resPrice = isThanSixSeat ? 1094 : 1252;
            break;
        case 100 * 10000:
            resPrice = isThanSixSeat ? 1425 : 1630;
            break;
        default:
            resPrice = isThanSixSeat ? 674 : 746;
            break;
    }
    var byhf = fwf + qx + zjxfs;
    if (!newEnergy) {
        byhf = byhf + gzs + ccs;
    }
    var sybx = resPrice + clssx + qcdqx + zrssx + bjmptyx + wgzrx + csryzrx + blx + cshhx;
    // allCost = byhf + sybx + baseCarPrice;
    var downPayments = byhf + sybx + baseCarPrice * rates; // 首付
    var rate = yearRate / 12 / 100; // 利率
    var monthCost;
    if (type == 1) {
        var allCost = byhf + sybx + baseCarPrice;
        var load = allCost - Math.round(downPayments); // 贷款额度
        monthCost =
            load *
                ((rate * Math.pow(1 + rate, months)) / (Math.pow(1 + rate, months) - 1));
        //    贷款额度 = 裸车价格 + 必要花费 + 商业保险 + 其他贷款费用 + 自定义项 - 首付金额  ----
        // monthCost = load * ((rate * Math.pow(1 + rate, 36)) / (Math.pow(1 + rate, 36) - 1));
    }
    else {
        monthCost =
            (baseCarPrice * (1 - rates) * (1 + (yearRate / 100) * (months / 12))) /
                months;
    }
    // console.log(baseCarPrice, monthCost);
    // monthCost = load * ((rate * Math.pow(1 + rate, months)) / (Math.pow(1 + rate, months) - 1))
    //    贷款额度 = 裸车价格 + 必要花费 + 商业保险 + 其他贷款费用 + 自定义项 - 首付金额  ----
    var moneys = {
        downPayments: (downPayments / 10000).toFixed(2),
        monthCost: Math.round(monthCost) + '',
    };
    // console.log("----必要话费", "购置税：", gzs, "服务费：", fwf, "车船税：", ccs, "交强险:", qx, "消费税：", zjxfs, "-----")
    // console.log("----商业保险", "第三责任险：", resPrice, "车辆损失险：", clssx, "全车盗抢险：", qcdqx, "自燃损失险:", zrssx, "不计免赔特约险：", bjmptyx, "无过责任险:", wgzrx, "车上人员责任险:", csryzrx, "玻璃单独破碎险:", blx, "车身划痕险:", cshhx, "-----")
    // console.log(config, baseCarPrice, newEnergy, byhf,sybx,downPayments,monthCost,seat)
    return moneys;
}
exports.carPurchaseCalculator = carPurchaseCalculator;
